
define('text!editor/edit/contexts/preview.html',[],function () { return '<div class="context-content">\r\n    <!--blank-->\r\n</div>';});

